<template>
  <v-layout column>
    <!-- Status -->
    <v-layout column justify-end align-start>
      <v-flex shrink>
        <IconTextHorizontal
          :icon="statusIconString"
          :iconColor="statusColor"
          :title="statusString"
          :subtitle="periodString"
        />
      </v-flex>

      <v-flex shrink>
        <IconTextHorizontal
          icon="fas fa-link"
          :iconColor="statusColor"
          title="Streak"
          :subtitle="project.streak"
        />
      </v-flex>
      <v-flex shrink>
        <IconTextHorizontal
          icon="far fa-calendar-alt"
          :iconColor="statusColor"
          title="Since"
          :subtitle="startDateString"
        />
      </v-flex>
    </v-layout>
    <br />
    <v-layout align-center wrap>
      <v-flex xs12 md6 class="pl-2">
        <v-slider
          :value="percentage"
          readonly
          height="5"
          :thumb-color="statusColor"
          :color="statusColor"
          always-dirty
        />
      </v-flex>

      <v-flex xs12 md6>
        <v-layout align-center justify-center>
          <v-flex xs4>
            <IconTextVertical
              :icon="
                operatorMore
                  ? 'fas fa-greater-than-equal'
                  : 'fas fa-less-than-equal'
              "
              :iconColor="statusColor"
              title="Goal"
              :subtitle="targetText"
            />
          </v-flex>
          <v-flex xs4>
            <IconTextVertical
              :icon="typeIconString"
              :iconColor="statusColor"
              title="Current"
              :subtitle="currentText"
            />
          </v-flex>
          <v-flex xs4>
            <IconTextVertical
              icon="fas fa-percentage"
              :iconColor="statusColor"
              title="Percentage"
              :subtitle="percentage"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>
<script>
import { Project } from "@/classes/Project/Project";
import { Time } from "@/lib/Time";
import IconTextHorizontal from "./IconTextHorizontal";
import IconTextVertical from "./IconTextVertical";
export default {
  props: {
    project: {
      type: Project
    }
  },
  methods: {
    toTimeString(duration) {
      let hour = Time.duration.as(duration, Time.unit.hour, true);
      let min = Time.duration.get(duration, Time.unit.minute);
      let sec = Time.duration.get(duration, Time.unit.second);
      return `${hour}:${min}:${sec}`;
    }
  },
  components: { IconTextHorizontal, IconTextVertical },
  computed: {
    statusIconString() {
      let success = "fas fa-check-square";
      let failure = "fas fa-times-circle";
      let progress = "fas fa-minus-square";
      if (this.project.isSuccess()) {
        return success;
      } else if (this.project.isPending()) {
        return progress;
      } else return failure;
    },
    typeIconString() {
      if (this.project.isDuration()) return "far fa-clock";
      else return "fas fa-check";
    },
    statusString() {
      let success = "Success";
      let failure = "Failure";
      let progress = "In Progress";
      if (this.project.isSuccess()) {
        return success;
      } else if (this.project.isPending()) {
        return progress;
      } else return failure;
    },
    statusColor() {
      let success = this.project.color;
      let failure = "black";
      let progress = this.project.color;
      if (this.project.isSuccess()) {
        return success;
      } else if (this.project.isPending()) {
        return progress;
      } else return failure;
    },
    periodString() {
      let startText =
        Time.date.monthString(
          this.project.blockStart,
          Time.date.getUTCOffSet()
        ) +
        " " +
        Time.date.dayString(this.project.blockStart, Time.date.getUTCOffSet());

      let endText =
        Time.date.monthString(this.project.blockEnd, Time.date.getUTCOffSet()) +
        " " +
        Time.date.dayString(this.project.blockEnd, Time.date.getUTCOffSet());

      return startText == endText
        ? `${startText}`
        : `${startText} ~ ${endText} `;
    },

    startDateString() {
      return `${Time.date.monthString(
        this.project.startTimestamp
      )} ${Time.date.dayString(
        this.project.startTimestamp
      )}, ${Time.date.yearString(this.project.startTimestamp)}`;
    },

    targetText() {
      return this.project.isDuration()
        ? this.toTimeString(this.project.target)
        : this.project.target;
    },
    operatorMore() {
      return this.project.operator === Project.operator.more;
    },
    currentText() {
      return this.project.isDuration()
        ? this.toTimeString(this.project.displayCurrent)
        : this.project.displayCurrent;
    },
    percentage() {
      return (this.project.displayPercentage * 100).toFixed(2);
    }
  }
};
</script>
